module.exports = __webpack_public_path__ + "img/温州吾悦.ff6e8bb5.png";